import service from '@/services/inventario/costoFijo'

const getDefaultState = () => ({
  costo: { nombre: '', descripcion: '', unidadMedida: { id: '' }, codigoMoneda: { id: '' }, costoUnitarioTotal: 0, cuentaContable: '', codigo: '' },

  lista: [], // lista de nombres de costo
  currentRow: null,
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => {
    state.costo = getDefaultState().costo
    state.costo.unidadMedida = {
      annotation: 'Unidad',
      id: '5efcc43a1feb334e4d49338c',
      value: 'Unid'
    }
    state.costo.codigoMoneda = { id: '5efcc43a1feb334e4d4933f4', value: 'CRC', simbolo: '¢' }
  },
  SET_ROW: (state, row) => (state.currentRow = row),
  SET: (state, obj) => {
    state.costo = obj
    state.saved = true
  },
  SET_LIST: (state, obj) => {
    state.lista = obj
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.lista.find(e => e._id === obj._id)
    if (!nObj) state.lista = [obj, ...state.lista]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  DELETE_LIST: (state, { obj }) => {
    state.lista = state.lista.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    state.costo = obj
    state.saved = false
  }
}

export const actions = {
  create: async ({ commit, rootGetters }, input) => {
    if (!input.cuentaContable) delete input.cuentaContable

    return service
      .create({
        ...input,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        commit('UPDATE_LIST', {
          ...input,
          _id: result._id
        })

        return result
      })
  },

  readById: async ({ commit }, input) => commit('SET', input),
  resetList: ({ state }) => (state.lista = []),
  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, force = false) => {
    if (state.lista.length && !force) return state.lista

    state.lista = []

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      commit('SET_LIST', result)
      return true
    })
  },
  delete: ({ commit, rootGetters }, { items }) =>
    service.delete(rootGetters['facturacion/emisorStore/get_Id'], items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', { obj: i })
      })
      return result
    }),

  saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}
